// import type { GenericNotification } from '@basehub/data/replicache/index'
import { JSONContent } from '@tiptap/core'

type GenericNotification = any

export function getMentionsFromJson(value: string | null | JSONContent) {
  let json: JSONContent
  try {
    json =
      typeof value === 'string'
        ? (JSON.parse(value) as JSONContent)
        : (value ?? { type: 'doc', content: [] })
  } catch (e) {
    return []
  }

  const mentions: string[] = []
  const traverse = (node: JSONContent) => {
    if (node.type === 'mention') {
      const userId = node.attrs?.id
      if (userId) mentions.push(userId)
    } else if (node.content) {
      node.content.forEach(traverse)
    }
  }
  traverse(json)

  return mentions.filter(Boolean)
}

export const shouldNotificationTriggerEmail = ({
  notification,
}: {
  notification: GenericNotification
}) => {
  return (
    notification.type === 'repo-thread-comment' ||
    notification.type === 'repo-cr-resolution' ||
    notification.type === 'workflow-action'
  )
}
